
import React, {FC} from 'react';
import Button from 'components/Button';
import {Variant} from 'components/Button/variants';

interface SubmitProps {
	children: string;
	className?: string;
	variant?: Variant;
}

export const Submit: FC<SubmitProps> = ({
	variant = 'primary',
	...rest
}) => {
	return (
		<Button
			type='submit'
			variant={variant}
			{...rest}
		/>
	);
};
